import { render } from "./UploadCountriesWithPackagesModal.vue?vue&type=template&id=04b58048"
import script from "./UploadCountriesWithPackagesModal.vue?vue&type=script&lang=js"
export * from "./UploadCountriesWithPackagesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__